import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { CommonModule, isPlatformBrowser, isPlatformServer } from '@angular/common';
// services
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { FormsModule } from '@angular/forms';
import { NotificationsComponent } from '@shared/components/notifications/notifications.component';
import { ValidateEmailComponent } from 'app/register/components/validate-email/validate-email.component';
declare var ga: any;

@Component({
  selector: 'app-validate-email-section',
  standalone: true,
  imports: [CommonModule, FormsModule, NotificationsComponent, ValidateEmailComponent],
  templateUrl: './validate-email-section.component.html',
  styleUrls: ['./validate-email-section.component.scss'],
  providers: [ErrorHandler]
})
export class ValidateEmailSectionComponent implements OnInit {

  // public showEmailSent: Boolean = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      ga('set', 'page', '/validate-email');
      ga('send', 'pageview');
    }
  }

}
